module.exports = __webpack_public_path__ + "static/8-5b99c90c020ff96586c00b085e638a41.jpeg";